<template>
  <div name="demo-validate-larger-than">
    <input type="text" v-validate="'required|date_format:DD/MM/YYYY'" data-vv-name="date1" :class="{ 'input-error' : errors.has('date1') }" />
    <div class="text-error" v-show="errors.has('date1')">{{ errors.first('date1') }}</div>
    <input type="text" v-validate="'required|date_format:DD/MM/YYYY|after:date1'" data-vv-name="date2" :class="{ 'input-error' : errors.has('date2') }" />
    <div class="text-error" v-show="errors.has('date2')">{{ errors.first('date2') }}</div>
  </div>
</template>

<script>
export default {
  name: 'demo-validate-larger-than',
  data () {
    return {
      date1: '',
      date2: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoValidateLargerThan.vue?17b2db6e